import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../../interfaces";
import { GET_PARENTS, GetParentsAction } from "./actionTypes";
import { getParentsError, getParentsSuccess } from "./actions";
import { getParents } from "../../../helpers/backend_helper";

function* getParentsSaga({ payload: { request } }: GetParentsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getParents,
      request as PaginateQuery
    );
    yield put(getParentsSuccess(response.data));
  } catch (error) {
    yield put(getParentsError(error));
  }
}

function* ParentsSaga() {
  yield takeEvery(GET_PARENTS, getParentsSaga);
}

export default ParentsSaga;
